document.addEventListener('DOMContentLoaded', function() {
  const condition = document.getElementById('condition-report');
  const popup = document.getElementById('condition-report-popup');
  const closeBtn = document.getElementById('condition-report-close');
  if (condition && popup) {
    condition.addEventListener('click', function() {
      popup.classList.toggle('active');
    });
    document.addEventListener('click', function(e) {
      if (!condition.contains(e.target) && !popup.contains(e.target)) {
        popup.classList.remove('active');
      }
    });
    if (closeBtn) {
      closeBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        popup.classList.remove('active');
      });
    }
  }
});
